import React, { Component } from "react";
import "./Loader.scss";
class Loader extends Component {
  render() {
    return (
      <div className="gca-loader">
        <img src="./images/2.svg" alt="img" />
      </div>
    );
  }
}

export default Loader;
